import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, isSupported, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBFlp_Nbp5GkitZE2xjc8cQHxaBdTiXvW0",
  authDomain: "itoldyouso-74e47.firebaseapp.com",
  projectId: "itoldyouso-74e47",
  storageBucket: "itoldyouso-74e47.firebasestorage.app",
  messagingSenderId: "412603146660",
  appId: "1:412603146660:web:c659459ecec1c30fffa131",
  measurementId: "G-P9KBJD67BX"
};

export function getFirebaseApp() {
  if (!firebaseConfig.apiKey) {
    console.warn('[firebase] Missing Firebase config; skipping init');
    return null;
  }

  const apps = getApps();
  return apps.length ? apps[0] : initializeApp(firebaseConfig);
}

export async function getFirebaseMessaging(): Promise<Messaging | null> {
  const supported = await isSupported().catch(() => false);
  if (!supported) {
    console.warn('[firebase] Messaging not supported in this environment');
    return null;
  }

  const app = getFirebaseApp();
  if (!app) return null;

  return getMessaging(app);
}

